import config from 'shared/config';

/**
 * Return whether it is time to refetch or not.
 * @param {number} lastFetchTime time in ms when the cache was built.
 * @param {number} maxCacheTime time in ms indicating when a refetch is needed. Default is 5 minutes.
 * @returns bool
 */
const mustRefetch = (lastFetchTime, maxCacheTime = config.MAX_CACHE_AGE) => {
	if (lastFetchTime !== undefined) {
		if (Date.now() - lastFetchTime < maxCacheTime) {
			return false;
		}
	}

	// cache is stale or does not exists. Refetch
	return true;
};

export default mustRefetch;
